import React from 'react'
import { createRoot, type Root } from 'react-dom/client'
import { logError } from '@core/Utils'
import { ShareBetButton } from '@core/Areas/Kambi/Components/ShareBetButton'

const enum LocalConstants {
  KambiCouponRefElement = '.mod-KambiBC-betslip-receipt-header__receipt-id span',
}

/**
 * Web component required to use inside the Kambi client
 * https://developer.mozilla.org/en-US/docs/Web/Web_Components
 */
export class BetSlipShare extends HTMLElement {
  private shadow: ShadowRoot
  private reactRoot: Root | null

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
    this.reactRoot = null
  }

  connectedCallback() {
    const mountPoint = document.createElement('div')
    this.shadow.appendChild(mountPoint)
    this.reactRoot = createRoot(mountPoint)

    const couponRef = document.querySelector(LocalConstants.KambiCouponRefElement)?.textContent

    if (couponRef && typeof couponRef === 'string') {
      this.reactRoot?.render(<ShareBetButton couponRef={couponRef} />)
    } else {
      logError('Kambi: Bet Loop share button widget did not find couponRef element', true)
    }
  }

  disconnectedCallback() {
    this.reactRoot?.unmount()
  }
}
